import { Tooltip } from '@carboncopyco/ui';
import { useRef } from 'react';
import { AssetLocationBreadcrumbsContent } from './AssetLocationBreadcrumbsContent';
import type { AssetLocationBreadcrumbsContentProps } from './AssetLocationBreadcrumbsContent';

type AssetLocationBreadcrumbsProps = Pick<
  AssetLocationBreadcrumbsContentProps,
  'location'
> & {
  organizationId: string;
  workspaceId: string;
};

export const AssetLocationBreadcrumbs = ({
  location,
  organizationId,
  workspaceId,
}: AssetLocationBreadcrumbsProps) => {
  const breadcrumbsRef = useRef();
  return (
    <>
      <div ref={breadcrumbsRef}>
        <AssetLocationBreadcrumbsContent
          location={location}
          organizationId={organizationId}
          workspaceId={workspaceId}
        />
      </div>
      <Tooltip
        trigger="mouseenter"
        noArrow
        placement="top-start"
        anchorRef={breadcrumbsRef}
        delay={[350, undefined]}
      >
        <div className="p-3">
          <AssetLocationBreadcrumbsContent
            location={location}
            withWorkspaceName
            workspaceId={workspaceId}
            organizationId={organizationId}
          />
        </div>
      </Tooltip>
    </>
  );
};
